import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlassX = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.0355 12.3787C18.426 11.9882 18.426 11.355 18.0355 10.9645C17.645 10.5739 17.0118 10.5739 16.6213 10.9645L14.5 13.0857L12.3787 10.9645C11.9882 10.5739 11.355 10.5739 10.9645 10.9645C10.574 11.355 10.574 11.9882 10.9645 12.3787L13.0858 14.4999L10.9644 16.6213C10.5739 17.0118 10.5739 17.645 10.9644 18.0355C11.3549 18.4261 11.9881 18.4261 12.3786 18.0355L14.5 15.9142L16.6214 18.0355C17.0119 18.4261 17.6451 18.4261 18.0356 18.0355C18.4261 17.645 18.4261 17.0118 18.0356 16.6213L15.9142 14.4999L18.0355 12.3787Z",
		fill: "#0A0B0D"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 14.5C3 8.14873 8.14873 3 14.5 3C20.8513 3 26 8.14873 26 14.5C26 17.3156 24.9881 19.8948 23.3082 21.894L28.7072 27.2929C29.0977 27.6834 29.0977 28.3166 28.7072 28.7071C28.3166 29.0976 27.6835 29.0976 27.2929 28.7071L21.894 23.3082C19.8949 24.9881 17.3156 26 14.5 26C8.14873 26 3 20.8513 3 14.5ZM14.5 5C9.25329 5 5 9.25329 5 14.5C5 19.7467 9.25329 24 14.5 24C19.7467 24 24 19.7467 24 14.5C24 9.25329 19.7467 5 14.5 5Z",
		fill: "#0A0B0D"
	})]
});
export default SvgMagnifyingGlassX;
